import React from "react";
import styled from "styled-components";
import breakpoints from "utils/breakpoints";
import PropTypes from "prop-types";
import Button from "components/components/atoms/Button";
import useBreakpoint from "utils/hooks/useBreakpoint";
import { useEffect } from "react";

const Container = styled.div`
  ${({ isMobile, noPaddingLeft }) =>
    !isMobile && !noPaddingLeft && `padding-left: 7.5rem; padding-right: 4rem;`}
`;

const Heading = styled.div`
  @media ${breakpoints.md} {
    font-size: 2.875rem;
    line-height: 3rem;
  }
`;

const NoResultSearch = ({ title, filter, cta = {}, noPaddingLeft }) => {
  const breakpoint = useBreakpoint(
    typeof window !== "undefined" && window.innerWidth
  );
  const isMobile = ["sm", "xs"].includes(breakpoint);

  useEffect(() => {
    setTimeout(() => {
      const e = document.getElementById("SearchNoResults");
      //console.log(e);
      if (e) {
        e.scrollIntoView({
          block: "start",
          behavior: "smooth",
          inline: "start",
        });
      }
    }, 500);
  }, []);

  return (
    <Container
      id={"SearchNoResults"}
      isMobile={isMobile}
      noPaddingLeft={noPaddingLeft}
      className="relative w-full h-auto px-5 pb-8 pb-2 md:px-0 md:py-60-mattamy bg-white items-start mt-10-mattamy"
    >
      <Heading
        className="w-full pb-6 md:pb-8 font-trade-gothic-20 text-mattamy-blue text-3xl leading-10 tracking-tighter text-left"
        role="status"
        tabIndex={-1}
      >
        {title}
        {/*  {filter && ` for “${filter}”`} */}
      </Heading>

      <Button
        color={"mattamy-blue"}
        variant="outlined"
        className="text-base h-60-mattamy pt-0 pb-0 uppercase "
        href={cta.href || undefined}
        onClick={!cta.href ? cta.onClick : undefined}
        buttonDescription={cta.text}
      >
        {cta.text}
      </Button>
    </Container>
  );
};

NoResultSearch.propTypes = {
  title: PropTypes.string,
  filter: PropTypes.string,
  cta: PropTypes.object,
};

export default NoResultSearch;
